import React from 'react'
import { Route } from 'react-router-dom'
import { ActionsAuthorizer } from '../../../Authorizer'

import OperatorsManagement from '../../../../views/Dashboard/Management/OperatorsManagement'
import OperatorRoutes from './OperatorRoutes'
import ManagementActions from '../ManagementActions'

const AuthorizedOperatorssManagement = ActionsAuthorizer(ManagementActions)(OperatorsManagement)
const AuthorizedOperatorRoutes = ActionsAuthorizer(ManagementActions)(OperatorRoutes)

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <div>
    <Route path={`${match.path}/operator`} component={AuthorizedOperatorRoutes} />
    <Route path={match.path} component={AuthorizedOperatorssManagement} />
  </div>
)
